import { Recurso } from "./recurso.model";


export class AtoRecurso {
    
    idAto: number;
	epigrafe: string;
	internet: boolean;
	publicado: boolean;

	recurso: Recurso;
}